import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["areEventsDraggable", "areEventsResizable", "canDragEventsFromTheOutside", "canDropEventsToTheOutside", "dateLocale", "defaultPreferences", "defaultView", "defaultVisibleDate", "defaultVisibleResources", "displayTimezone", "eventColor", "eventCreation", "eventModelStructure", "events", "onEventsChange", "onViewChange", "onVisibleDateChange", "onVisibleResourcesChange", "preferences", "preferencesMenuConfig", "readOnly", "dataSource", "shouldEventRequireResource", "resourceModelStructure", "resources", "showCurrentTimeIndicator", "view", "views", "visibleDate", "visibleResources"];
/* eslint-disable react-compiler/react-compiler -- intentional `react-hooks/exhaustive-deps` disable below */
import * as React from 'react';
export function useExtractEventCalendarParameters(props) {
  const {
      areEventsDraggable,
      areEventsResizable,
      canDragEventsFromTheOutside,
      canDropEventsToTheOutside,
      dateLocale,
      defaultPreferences,
      defaultView,
      defaultVisibleDate,
      defaultVisibleResources,
      displayTimezone,
      eventColor,
      eventCreation,
      eventModelStructure,
      events,
      onEventsChange,
      onViewChange,
      onVisibleDateChange,
      onVisibleResourcesChange,
      preferences,
      preferencesMenuConfig,
      readOnly,
      dataSource,
      shouldEventRequireResource,
      resourceModelStructure,
      resources,
      showCurrentTimeIndicator,
      view,
      views,
      visibleDate,
      visibleResources
    } = props,
    forwardedProps = _objectWithoutPropertiesLoose(props, _excluded);
  const parameters = React.useMemo(() => ({
    areEventsDraggable,
    areEventsResizable,
    canDragEventsFromTheOutside,
    canDropEventsToTheOutside,
    dateLocale,
    defaultPreferences,
    defaultView,
    defaultVisibleDate,
    defaultVisibleResources,
    displayTimezone,
    eventColor,
    eventCreation,
    eventModelStructure,
    events,
    onEventsChange,
    onViewChange,
    onVisibleDateChange,
    onVisibleResourcesChange,
    preferences,
    preferencesMenuConfig,
    readOnly,
    dataSource,
    shouldEventRequireResource,
    resourceModelStructure,
    resources,
    showCurrentTimeIndicator,
    view,
    views,
    visibleDate,
    visibleResources
  }),
  // `dataSource` is intentionally excluded. It's re-read on every fetch, but the
  // cache + dataManager are pinned to the original instance, so runtime swaps are
  // only partially reactive — consumers should remount to swap. Including it in
  // deps would invalidate the memo every render for inline `{ getEvents, persistEvents }`.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [areEventsDraggable, areEventsResizable, canDragEventsFromTheOutside, canDropEventsToTheOutside, dateLocale, defaultPreferences, defaultView, defaultVisibleDate, defaultVisibleResources, displayTimezone, eventColor, eventCreation, eventModelStructure, events, onEventsChange, onViewChange, onVisibleDateChange, onVisibleResourcesChange, preferences, preferencesMenuConfig, readOnly, shouldEventRequireResource, resourceModelStructure, resources, showCurrentTimeIndicator, view, views, visibleDate, visibleResources]);
  return {
    parameters,
    forwardedProps: forwardedProps
  };
}